// removed by extract-text-webpack-plugin
module.exports = {"container":"lsvi--calculadora__App__container_1","title":"lsvi--calculadora__App__title_1","loading":"lsvi--calculadora__App__loading_1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"localIdentName":"lsvi--calculadora__[name]__[local]_1","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02efb492","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 33
// module chunks = 0